import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className={`flex-grow mt-[120px] ml-1 mr-1 mb-4`}>
                <div className="max-w-[1100px] mx-auto py-0 md:py-8 ">
                    {children}
                </div>
            </main>
            <Footer />
        </div>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;